import React, { useState, useEffect } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload, message } from "antd";
import axios from "axios";
import ImgCrop from "antd-img-crop";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const UploadImageProfile = ({
  name = "users",
  disabled = false,
  imageUrl = "",
  onImageUploaded,
  isUploading,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (imageUrl) {
      setFileList([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: imageUrl,
        },
      ]);
    }
  }, [imageUrl]);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const customRequest = async (options) => {
    const { file, onSuccess, onError, onProgress } = options;

    const formData = new FormData();
    formData.append("name", name);
    formData.append("file", file);
    isUploading(true);
    try {
      const response = await axios.post(
        "https://pro1.edunezam.com/api/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (event) => {
            const percent = Math.round((event.loaded * 100) / event.total);
            if (onProgress) {
              onProgress({ percent });
            }
          },
        }
      );

      const result = response.data;

      const uploadedUrl = result.url || result.fileUrl || result.path || "";

      if (uploadedUrl && typeof onImageUploaded === "function") {
        onImageUploaded(uploadedUrl);
      }

      message.success("Upload successful!");
      onSuccess(result, file);
      isUploading(false);
    } catch (error) {
      console.error("Upload error:", error);
      message.error("Upload failed.");
      onError(error);
    }
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  return (
    <>
      <ImgCrop rotationSlider>
        <Upload
          customRequest={customRequest}
          listType="picture-card"
          fileList={fileList}
          onPreview={handlePreview}
          onChange={handleChange}
          maxCount={1}
          disabled={disabled}
          type="image"
        >
          {fileList.length >= 1 ? null : uploadButton}
        </Upload>
      </ImgCrop>
      {previewImage && (
        <Image
          className="z-50"
          wrapperStyle={{ display: "none" }}
          // preview={{
          //   // visible: previewOpen,
          //   onVisibleChange: (visible) => setPreviewOpen(visible),
          //   afterOpenChange: (visible) => !visible && setPreviewImage(""),
          // }}
          preview={false}
          src={previewImage || "/placeholder.svg"}
        />
      )}
    </>
  );
};

export default UploadImageProfile;
